import type { UseQueryOptions } from "@tanstack/react-query";

/** Shared defaults for case-checking list/detail queries (avoid focus refetch duplicates). */
export const caseCheckQueryDefaults = {
  staleTime: 30_000,
  refetchOnWindowFocus: false,
} satisfies Partial<UseQueryOptions>;
